"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoyaltyStatementDownloadForm = void 0;
const react_1 = __importStar(require("react"));
const Radio_1 = __importDefault(require("@Components/Radio"));
const Button_1 = require("@Components/Buttons/Button");
const statements_1 = require("@App/api/routes/rightsholder/statements");
const contexts_1 = require("@App/contexts");
const RoyaltyStatementDownloadForm = (props) => {
    const [downloadFormat, setDownloadFormat] = (0, react_1.useState)('summary');
    const [downloadType, setDownloadType] = (0, react_1.useState)('consolidated');
    const { preloaderStore, rightsholderStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const submitTsvRequest = () => {
        preloaderStore.openTransparentPreloader(true);
        (0, statements_1.createTsvRequest)(rightsholderStore.currentRightsholderId, {
            format: downloadFormat,
            fileType: downloadType,
            data: props.downloadData,
        }).then();
        props.setIsFormSubmitted(true);
        preloaderStore.openTransparentPreloader(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Radio_1.default, { options: [
                {
                    id: 1,
                    value: 'summary',
                    label: 'Work Summary',
                    description: 'This format provides royalty data summarized at the musical work level.',
                },
                {
                    id: 2,
                    value: 'details',
                    label: 'Royalty Detail',
                    description: 'This format provides royalty data ' +
                        'corresponding with the individual sound recordings contained in' +
                        ' DSP usage reports.',
                },
            ], field: { name: 'Format' }, title: 'Format:', defaultCheckedId: 1, onChange: (option) => setDownloadFormat(option.value) }),
        react_1.default.createElement(Radio_1.default, { options: [
                {
                    id: 3,
                    value: 'consolidated',
                    label: 'Consolidated',
                    description: 'This file type will combine all selected data into one file.',
                },
                {
                    id: 4,
                    value: 'individual',
                    label: 'Individual',
                    description: 'This file type will preserve separate files for all selected data.',
                },
            ], field: { name: 'File Type' }, title: 'File Type:', defaultCheckedId: 3, onChange: (option) => setDownloadType(option.value) }),
        react_1.default.createElement("div", { className: 'download-button' },
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: () => submitTsvRequest() }, "Download"))));
};
exports.RoyaltyStatementDownloadForm = RoyaltyStatementDownloadForm;
